module.exports = __webpack_public_path__ + "img/Constant Learner.f07d19b3.svg";